import type { TFunction } from 'i18next';

/**
 * Turn a quantile key into something a lawyer reads without a statistics course.
 *
 * The charts previously plotted `p10 p25 p50 p75 p90` straight from the API,
 * which is the notation an analyst uses and nobody else does. Nothing anywhere
 * in the product defined it — including the field guides, whose entire job is
 * explaining the numbers, and which used "p90" while explaining something else.
 *
 * Falls back to the raw key: the ladder comes from the analytics layer and may
 * grow a quantile this map does not know, and an unlabelled point is better
 * than a blank one.
 */
export function quantileLabel(t: TFunction, key: string): string {
  return t(`anatel:quantiles.${key}`, { defaultValue: key });
}
